import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=86b507b6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
import style0 from "./Home.vue?vue&type=style&index=0&id=86b507b6&prod&scoped=true&lang=stylus"
import style1 from "./Home.vue?vue&type=style&index=1&id=86b507b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b507b6",
  null
  
)

export default component.exports